import { UrqlGqlLimitedUniversal } from '@pypestream/api-services/urql.limited-access.universal';

export interface SmartServiceConfig {
  endpoints: {
    gql: string;
    wss: string;
    kratos: string;
  };
  launchDarklyKey?: string;
}

type UniversalSdk = ReturnType<UrqlGqlLimitedUniversal['getGqlClientSdk']>;

let gqlSdk: UniversalSdk | undefined;
let smartServiceConfig: SmartServiceConfig | undefined;

export function setGqlSdk(sdk: UniversalSdk): void {
  gqlSdk = sdk;
}

export function getGqlSdk(): UniversalSdk {
  if (!gqlSdk) {
    throw new Error(
      '@pypestream/design-system: initSmartService() must be called before using the GraphQL client'
    );
  }
  return gqlSdk;
}

export function setSmartServiceConfig(config: SmartServiceConfig): void {
  smartServiceConfig = config;
}

export function getSmartServiceConfig(): SmartServiceConfig | undefined {
  return smartServiceConfig;
}
